import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {
  createGiftGallery,
  deleteGiftGallery,
  getGiftGalleryById,
  getGiftGalleryList,
  updateGiftGallery,
} from '../../services/GiftGalleryService'

interface GetGiftGalleryListParams {
  pageNumber: number
  pageSize: number
  filterkey: any
}

interface GiftGalleryState {
  GiftGalleryList: any
  giftGallery: any
}

const initialState: GiftGalleryState = {
  GiftGalleryList: null,
  giftGallery: null,
}

// Fetch giftGallery list
export const getGiftGalleryListApi = createAsyncThunk(
  'giftGallery/getGiftGalleryList',
  async ({pageNumber, pageSize, filterkey}: GetGiftGalleryListParams, {rejectWithValue}) => {
    try {
      const result = await getGiftGalleryList(pageNumber, pageSize, filterkey)
      return result.data
    } catch (error) {
      return rejectWithValue({error})
    }
  }
)

// Fetch giftGallery by ID
export const getGiftGalleryByIdApi = createAsyncThunk(
  'giftGallery/getGiftGalleryById',
  async (id: any, {rejectWithValue}) => {
    try {
      const result = await getGiftGalleryById(id)
      return result.data
    } catch (error) {
      return rejectWithValue({error})
    }
  }
)

// Create a new giftGallery
export const createGiftGalleryApi = createAsyncThunk(
  'giftGallery/createGiftGallery',
  async (payload: any, {rejectWithValue}) => {
    try {
      const result = await createGiftGallery(payload)
      return result.data
    } catch (error) {
      return rejectWithValue({error})
    }
  }
)

// Update giftGallery
export const updateGiftGalleryApi = createAsyncThunk(
  'giftGallery/updateGiftGallery',
  async ({id, payload}: {id: any; payload: any}, {rejectWithValue}) => {
    try {
      const result = await updateGiftGallery(id, payload)
      return result.data
    } catch (error) {
      return rejectWithValue({error})
    }
  }
)

// Delete giftGallery
export const deleteGiftGalleryApi = createAsyncThunk(
  'giftGallery/deleteGiftGallery',
  async (id: any, {rejectWithValue}) => {
    try {
      const result = await deleteGiftGallery(id)
      return result.data
    } catch (error) {
      return rejectWithValue({error})
    }
  }
)

const GiftGallerySlice = createSlice({
  name: 'giftGallery',
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(getGiftGalleryListApi.fulfilled, (state, action) => {
        state.GiftGalleryList = action.payload
      })
      .addCase(getGiftGalleryByIdApi.fulfilled, (state, action) => {
        state.giftGallery = action.payload
      })
      .addCase(createGiftGalleryApi.fulfilled, (state, action) => {
        state.giftGallery = action.payload
      })
      .addCase(updateGiftGalleryApi.fulfilled, (state, action) => {
        state.giftGallery = action.payload
      })
      .addCase(deleteGiftGalleryApi.fulfilled, (state, action) => {
        state.giftGallery = null // Assuming after deletion you want to clear the giftGallery state
        // Alternatively, you could modify the GiftGalleryList if necessary.
      })
  },
})

export default GiftGallerySlice
